import {
    useLazyGetAppDefaultsQueryQuery,
    usePutAppDefaultsMutation,
} from '../../redux/rtkquery/paylogikApi';
import React, {useMemo, useState} from 'react';
import {useAppSelector} from '../../redux/functions/hooks';
import {ColDef} from 'ag-grid-community';
import PlAgGrid from '../common/PlAgGrid';
import {canIFunc, action} from '../../CanI';

export default function ManageAppDefaults(props) {
    const [makeCall] = useLazyGetAppDefaultsQueryQuery();
    const [putModification] = usePutAppDefaultsMutation();

    const auth = useAppSelector((x) => x.auth);

    //Column definitions aside from Delete column (added programatically)
    const getColumnDefs = () => {
        return [
            {
                field: 'parmID',
                headerName: 'Parameter',
                initialSort: 'asc',
                flex: 2,
                editable: false,
            },
            {field: 'parmGroup', headerName: 'Group', flex: 2, editable: false},
            {
                field: 'parmDescrip',
                headerName: 'Description',
                tooltipField: 'parmDescrip',
                flex: 4,
                editable: false,
            },
            {field: 'parmValue', headerName: 'Value', flex: 2, editable: true},
        ] as ColDef[];
    };
    const [columnDefs] = useState(getColumnDefs());

    //"Edit" security check
    const canEdit = useMemo(() => {
        return canIFunc(auth, 'Frm_ManageAppDefaults', action.VIEW);
    }, [auth]);

    return (
        <PlAgGrid
            makeCall={makeCall}
            putMutation={putModification}
            getPutMutationObject={(event) => {
                const data = event.data;
                const field = event.colDef.field;
                const newValue = event.newValue;
                if (!data || !field) {
                    return;
                }
                const newItem = {...data};
                newItem[field] = newValue.toUpperCase();

                return {
                    parmId: data.parmID,
                    appDefaultVm: newItem,
                };
            }}
            columns={columnDefs}
            getRowId={(params) => params.data.parmID}
            canEdit={canEdit}
        />
    );
}
